import styled from '@emotion/styled';

export const DrawerContent = styled('div')(
  () => `
  width: 600px;

  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 75px;
    padding: 0 40px;
  }

  .content {
    padding: 35px;
  }
`,
);
